var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionTitle',[_vm._v("Atividades recentes")]),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box__inner"},[_c('div',{staticClass:"box__inner__deep"},[_c('TimelineActivities',{attrs:{"user-id":_vm.user.id}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }